module.exports = __webpack_public_path__ + "static/media/page_not_found.1abc4f1e.svg";